var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('abk-survey-form',{attrs:{"survey-id":_vm.$route.params.id,"submit-action":_vm.updateSurvey,"validate-action":_vm.validate}})}
var staticRenderFns = []

export { render, staticRenderFns }